
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wissen",
      function () {
        return require("private-next-pages/wissen.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wissen"])
      });
    }
  